// extracted by mini-css-extract-plugin
module.exports = {"mCard":"yb-z","image":"zb-z","imageNoBackground":"Ab-z"};